import { render, staticRenderFns } from "./DynamicMarket.vue?vue&type=template&id=3a687db8&scoped=true"
import script from "./DynamicMarket.vue?vue&type=script&lang=js"
export * from "./DynamicMarket.vue?vue&type=script&lang=js"
import style0 from "./DynamicMarket.vue?vue&type=style&index=0&id=3a687db8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a687db8",
  null
  
)

export default component.exports